<template>
  <div class="market-check-index">
    <el-tabs v-model="tabsKey" type="card" :closable="false" :before-leave="onTabClick" >
      <el-tab-pane label="购券记录">
        <div class="tab-content">
          <BuyRecord></BuyRecord>
        </div>
      </el-tab-pane>
      <el-tab-pane label="券核销记录">
        <div class="tab-content">
          <CheckRecord></CheckRecord>
        </div>
      </el-tab-pane>
        <el-tab-pane label="手动发券明细" v-if="USER_BUTTON_AUTH.indexOf('market\:coupon\:task\:read') >= 0">
          <div class="tab-content">
            <GrantRecord></GrantRecord>
          </div>
        </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BuyRecord from './couponBuyRecord'
import CheckRecord from './couponCheckRecord'
import GrantRecord from './couponGrantRecord'
import { getStorage } from '@/utils/index'
export default {
  name: "mvcIndex",
  components: {
    BuyRecord,
    CheckRecord,
    GrantRecord,
  },
  data() {
    return {
      tabsKey: 0,
      USER_BUTTON_AUTH:[],
    };
  },
  created () {
    this.USER_BUTTON_AUTH = getStorage('USER_BUTTON_AUTH')
  },
  methods: {
    onTabClick() {

    },
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-check-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;

  .tab-content {
    margin-top: -30px;
  }
}
</style>
